import { RootTranslateServiceConfig, TranslateLoader, TranslationObject } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import svSE from "./languages/sv-SE.json";

class LanguageLoader implements TranslateLoader {
    getTranslation(_lang: string): Observable<TranslationObject> {
        return of(svSE);
    }
}

export const translateModuleConfig: RootTranslateServiceConfig = {
    loader: {
        provide: TranslateLoader,
        useClass: LanguageLoader
    }
};
